import { ButtonGroup, makeStyles } from '@material-ui/core';
import { theme } from '../../../theme/theme';
import { usePrefixTranslation } from '../../../i18n';
import React from 'react';
import { Button } from '../../global';

const useUpcomingBarClasses = makeStyles({
    root: {
        boxShadow: 'none',
        '& > button': {
            padding: '5px 15px',
        },
        '& > button:not(.selected)': {
            background: `${theme.colors.neutral[8]} !important`,
            color: `${theme.colors.darkBlue[5]} !important`,
        },
        '& > button:first-child': {
            borderRadius: '18px 0 0 18px',
        },
        '& > button:last-child': {
            borderRadius: '0 18px 18px 0',
        },
    },
});

export const ProjectListUpcomingBar = (props: {
    days: number[];
    default: number;
    selected: number;
    enabled?: boolean;
    onClick: (days: number) => void;
}) => {
    const classes = useUpcomingBarClasses();
    const { t } = usePrefixTranslation('project', { project: 'list.ProjectList' });

    React.useEffect(() => {
        if (!props.days.includes(props.selected)) props.onClick(props.default);
    }, []);

    return (
        <ButtonGroup className={classes.root} variant='contained' size='small'>
            {props.days.map(days => (
                <Button
                    key={days}
                    className={days === props.selected ? 'selected' : ''}
                    onClick={() => props.onClick?.(days)}
                >
                    {days}
                    {t('days')}
                </Button>
            ))}
        </ButtonGroup>
    );
};
